import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export const Name = z.string().transform((s) => s.trim().replaceAll(/\s\s+/g, " "));

export const PhoneNumber = z.string().refine((t) => isValidPhoneNumber(t), {
    error: "Phone number is invalid",
});

export const Email = z
    .email({ error: "Email address is invalid" })
    .refine((e) => e.toLowerCase() === e, "Email address is invalid");

export type Name = z.infer<typeof Name>;
export type PhoneNumber = z.infer<typeof PhoneNumber>;
export type Email = z.infer<typeof Email>;

export const LoginSentinelValueEmail = "EMAIL_NOT_SET";
export const LoginSentinelValuePhoneNumber = "PHONE_NUMBER_NOT_SET";

/*
 * This is a sentinel value that is used to indicate that the user has not yet given us the value for the email or phone number.
 */
export const LoginSentinelValue = {
    email: z.literal(LoginSentinelValueEmail),
    phoneNumber: z.literal(LoginSentinelValuePhoneNumber),
};
